/*!
 * @license
 * Alfresco Example Content Application
 *
 * Copyright (C) 2005 - 2020 Alfresco Software Limited
 *
 * This file is part of the Alfresco Example Content Application.
 * If the software was purchased under a paid Alfresco license, the terms of
 * the paid license agreement will prevail.  Otherwise, the software is
 * provided under the following open source license terms:
 *
 * The Alfresco Example Content Application is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Lesser General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * The Alfresco Example Content Application is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Lesser General Public License for more details.
 *
 * You should have received a copy of the GNU Lesser General Public License
 * along with Alfresco. If not, see <http://www.gnu.org/licenses/>.
 */

import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { AppConfigService, LoginComponent } from '@alfresco/adf-core';
import { APP_CONFIG_PLUGINS, EFLOW_INTEGRATION_SERVICE, EFLOW_PLUGIN } from '../../models/alden-constants';
import { FormControl, FormGroup } from '@angular/forms';
import { isPluginEnabled } from '../../utils/plugin-utils';

export type LoginForm = {
  username: FormControl<string>;
  password: FormControl<string>;
};

@Component({
  templateUrl: './login.component.html'
})
export class AldenLoginComponent implements OnInit {

  @ViewChild('login') login: LoginComponent;

  currentYear: number;
  plugins: { [pluginId: string]: boolean | string };

  constructor(
    private appConfigService: AppConfigService,
    private injector: Injector
  ) {
    this.plugins = this.appConfigService.get(APP_CONFIG_PLUGINS);
  }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear();
  }
  
  onFormSubmit(_e) {
    if(isPluginEnabled(this.plugins, EFLOW_PLUGIN)){
      const loginForm: FormGroup<LoginForm> = this.login.form;
      const username = loginForm.controls.username.value;
      const password = loginForm.controls.password.value;

      const service = this.injector.get<any>(EFLOW_INTEGRATION_SERVICE);
      return service.camundaService.setAuth(username, password);
    }
  }
}
